import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ac-container" }
const _hoisted_2 = { class: "lang-toggle" }
const _hoisted_3 = { class: "lang-pill" }
const _hoisted_4 = { class: "lang-pill" }
const _hoisted_5 = {
  key: 0,
  class: "ac-filtered-items"
}
const _hoisted_6 = ["onClick", "onMouseover"]
const _hoisted_7 = { class: "chat-code" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      class: "search-input",
      type: "search",
      placeholder: "Search for chatlink ...",
      title: "Input is case sensitive!",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchInput) = $event)),
      onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.blur && _ctx.blur(...args))),
      onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.inputChanged && _ctx.inputChanged(...args))),
      onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args))),
      onKeyup: [
        _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.escape && _ctx.escape(...args)), ["esc"])),
        _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.enter && _ctx.enter(...args)), ["enter"]))
      ],
      onKeydown: [
        _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.enter && _ctx.enter(...args)), ["tab"])),
        _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.up && _ctx.up(...args)), ["up"])),
        _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.down && _ctx.down(...args)), ["down"]))
      ]
    }, null, 544), [
      [_vModelText, _ctx.searchInput]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          id: "cbxLangEng",
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.cbxLangEng) = $event)),
          "true-value": "true",
          "false-value": "false",
          checked: ""
        }, null, 512), [
          [_vModelCheckbox, _ctx.cbxLangEng]
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("span", null, "eng", -1))
      ]),
      _createElementVNode("label", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          id: "cbxLangGer",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cbxLangGer) = $event)),
          "true-value": "true",
          "false-value": "false"
        }, null, 512), [
          [_vModelCheckbox, _ctx.cbxLangGer]
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("span", null, "ger", -1))
      ])
    ]),
    (_ctx.showItems)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResult, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["ac-filtered-item", { 'ac-filtered-item__hovered': index === _ctx.cursor }]),
              key: index,
              onClick: ($event: any) => (_ctx.selectItem(item)),
              onMouseover: ($event: any) => (_ctx.cursor = index)
            }, [
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(item.name) + ", ", 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(item.chat_link), 1)
              ])
            ], 42, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}